import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { acceptClassificationResult } from "@/api/reviews";
import { classificationResultQueryKey } from "./classificationResultQueryKey";

interface AcceptArgs {
  inboundClassificationResultId: string;
  reason: string;
}

export function useAcceptClassificationResult() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ inboundClassificationResultId, reason }: AcceptArgs) => {
      return acceptClassificationResult({
        inbound_classification_result_id: inboundClassificationResultId,
        reason,
      });
    },
    onSuccess: async (_data, variables) => {
      toast.success("Result accepted");
      await queryClient.invalidateQueries({
        queryKey: classificationResultQueryKey(variables.inboundClassificationResultId),
      });
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to accept result");
    },
  });
}
